import React from 'react'
import { useAssetRendition } from '../hooks/useAssetRendition'
import Wait from '@react/react-spectrum/Wait'
import { buildClasses } from '@demo-system/commons/utilities/styles'

export function ImageBox({ asset, projectId, isSelected, onSelect }) {
  const { url, loading, error } = useAssetRendition(projectId, asset.id)

  //TODO: add intersection observer for assets rendition loading
  const handleClick = () => {
    onSelect(asset)
  }

  return (
    <button
      type='button'
      className={buildClasses('ImageBox__imageWrapper', { selected: isSelected })}
      onClick={handleClick}
      disabled={loading || !url}
    >
      {(loading || !url) && <Wait size='S' />}
      {error && <div className='ImageBox__imageWrapper'>Failed to load</div>}
      {!loading && !error && url && (
        <img src={url} alt={asset.originalImage?.alt || asset.name || asset.id} draggable={false} />
      )}
    </button>
  )
}
